
// src/pages/Home.jsx
import React, { useEffect, useState } from 'react';

// import Navbar from '../Home/Navbar.jsx';
import Hero from '../Home/Hero.jsx';
import Partners from '../Home/Partners.jsx';
import Roadmap from '../Home/Roadmap.jsx';
import Programs from '../Home/Programs.jsx';
import Mentors from '../Home/Mentors.jsx';
import CareerPaths from '../Home/CareerPaths.jsx';
import JobReady from '../Home/JobReady.jsx';
import Companies from '../Home/Companies.jsx';
import CTA from '../Home/CTA.jsx';
import Footer from '../Home/Footer.jsx';

import useReveal from '../hooks.js/useReveal.js';

export default function Home() {
  // Dark mode preference
  const [dark, setDark] = useState(
    typeof window !== 'undefined' && localStorage.getItem('theme') === 'dark'
  );

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [dark]);

  // Attach intersection observer for reveal animations
  useReveal();

  return (
    <div className="bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      {/* Top Info Bar */}
      <div className="bg-gradient-to-r from-brand-600 to-brand-700 text-white text-sm">
        <div className="max-w-7xl mx-auto px-4 py-2 text-center">
          🚀 New: AI Career Roadmap — free expert review within 24 hours
        </div>
      </div>

      {/* <Navbar dark={dark} setDark={setDark} /> */}

      <main>
        <Hero />
        <Partners />
        <Roadmap />
        <Programs />
        <Mentors />
        <CareerPaths />
        <JobReady />
        <Companies />
        <CTA />
      </main>

      {/* <Footer      <Footer /> */}
    </div>
  );
}
